module.exports = __webpack_public_path__ + "static/media/1_en.5a10f0bf.png";